import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import PageHeader from "../shared-components/PageHeader";

import { useEffect } from "react";
import Button, {
  ButtonColorTypes,
  ButtonTypes,
} from "../shared-components/Button";

import "react-day-picker/dist/style.css";

import { useGetReportLogs } from "../api/ReportsApi";
import LogsComponent from "./Logs";
import Container from "../shared-components/Container";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import ErrorMessageContainer from "../shared-components/ErrorMessageContainer";
import { ReportAuxiliaryLocationState } from "./reportNavigationUnlock";
import { useReportAuxiliaryLeaveUnlock } from "./useReportAuxiliaryLeaveUnlock";

const RETURN_TO_QUERY_PARAM = "returnTo";

function isInternalAppPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//");
}

const ReportLogs = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { isLoading, data: logsListData, mutate: getLogs } = useGetReportLogs();
  const { modal, errorUnlockingReport } = useReportAuxiliaryLeaveUnlock();

  useEffect(() => {
    if (id) {
      getLogs(id);
    }
  }, [getLogs, id]);

  const goBack = () => {
    const returnTo = searchParams.get(RETURN_TO_QUERY_PARAM);
    if (returnTo && isInternalAppPath(returnTo)) {
      navigate(returnTo);
      return;
    }
    const fromPath = (location.state as ReportAuxiliaryLocationState | null)
      ?.fromPath;
    if (fromPath && isInternalAppPath(fromPath)) {
      navigate(fromPath);
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    if (id) {
      navigate(`/reports/${id}/summary`);
    }
  };

  if (errorUnlockingReport) {
    return (
      <>
        {modal}
        <ErrorMessageContainer message="Error Unlocking Report" />
      </>
    );
  }

  return (
    <div>
      {modal}
      <Button
        text="Back"
        onClick={goBack}
        colorType={ButtonColorTypes.custom}
        type={ButtonTypes.back}
        className="w-20	h-20 max-w-xs max-h-9 px-0 items-start my-1"
      />
      <PageHeader title={"Report Logs"}></PageHeader>
      <div className="">
        {logsListData ? (
          <LogsComponent data={logsListData} header={[]} />
        ) : (
          <Container className="flex justify-center">
            {isLoading && <LoadingSpinner />}
            {!isLoading && <> No logs to show.</>}
          </Container>
        )}
      </div>
    </div>
  );
};

export default ReportLogs;
